import React from 'react';

import { SmarticoInboxButton as Smartico } from '@atlas/components';
import { SiteConfigManager, useApplicationState } from '@atlas/core';

import { useSmartico } from 'components/ClientProfile/Achievements/Smartico';

const SmarticoInboxButton = () => {
  const { openInbox, unreadMessagesCount } = useSmartico();
  const { authenticated } = useApplicationState();

  const isSmarticoInboxEnabled = SiteConfigManager.getConfig(
    'config.config.gamification.smartico.enableInbox',
  );

  if (!isSmarticoInboxEnabled || !authenticated) return null;

  return (
    <div className="header-info__smartico">
      <Smartico messagesCount={unreadMessagesCount} onClick={openInbox} />
    </div>
  );
};

export default SmarticoInboxButton;
